var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHammerWar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M352.125 32C348.25 32 357.125 30.75 216 54.25V24C216 10.745 205.255 0 192 0H192C178.745 0 168 10.745 168 24V54.25C26.25 30.625 35.75 32 31.875 32C14.625 32 0 46 0 64V256C0 274 14.625 288 32 288C35.75 288 26.875 289.25 168 265.75V488C168 501.255 178.745 512 192 512H192C205.255 512 216 501.255 216 488V265.75C357.75 289.375 348.25 288 352 288C369.375 288 384 274 384 256V64C384 46 369.375 32 352.125 32ZM336 237.125L192 213.125L48 237.125V82.875L192 106.875L336 82.875V237.125Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHammerWar);
export default __webpack_public_path__ + "static/media/hammer-war.03c5ed13012f45729a18cf5d48827cb5.svg";
export { ForwardRef as ReactComponent };